import React from "react";
import { useCountUp } from "@/hooks/useCountUp";

export const Counter = ({ to, duration = 1500, decimals = 0, prefix = "", suffix = "", className = "" }) => {
  const { ref, display } = useCountUp({ to, duration, decimals, prefix, suffix });
  return (
    <span ref={ref} className={className}>
      {display}
    </span>
  );
};
